const DOMAIN_PARTS = '([-a-zA-Z0-9а-яА-Яё_]{1,63}\\.)+';
/**
 * Каждый сегмент домена содержит хотя бы одну букву.
 * Исключает ложные срабатывания на нумерованных списках (1.текст.проверка)
 */
const DOMAIN_PARTS_WITH_LETTER =
  '((?=[-a-zA-Z0-9а-яА-Яё_]*[a-zA-Zа-яА-Яё])[-a-zA-Z0-9а-яА-Яё_]{1,63}\\.)+';
const TLD = '[-a-zA-Z0-9а-яА-Яё]{2,63}';
/**
 * TLD, содержащий хотя бы одну букву.
 * Исключает ложные срабатывания на числах с точкой (20.20, 10.30, 3.14)
 */
const TLD_WITH_LETTER = `(?=[-a-zA-Z0-9а-яА-Яё]*[a-zA-Zа-яА-Яё])${TLD}`;
const PATH = '(/[-a-zA-Z0-9а-яА-Яё()@:%_+.!,*$`~#?&//=]*)?';
const PROTOCOL = '(\\w+://)';

const PATTERN_URL_WITHOUT_PROTOCOL = `${DOMAIN_PARTS}${TLD}${PATH}`;

/**
 * С протоколом — допускается любой TLD (в т.ч. IP-адреса: http://192.168.1.10).
 * Без протокола — TLD должен содержать хотя бы одну букву,
 * каждый сегмент домена должен содержать хотя бы одну букву
 * (исключает «1.текст.проверка», но сохраняет «t.me», «2gis.ru»).
 */
const PATTERN_URL_WITH_OPTIONAL_PROTOCOL = `${PROTOCOL}${PATTERN_URL_WITHOUT_PROTOCOL}|${DOMAIN_PARTS_WITH_LETTER}${TLD_WITH_LETTER}${PATH}`;
const PATTERN_URL_WITH_OPTIONAL_PROTOCOL_WORD = `^(?:${PATTERN_URL_WITH_OPTIONAL_PROTOCOL})$`;
const PATTERN_URL_WITH_REQUIRED_PROTOCOL = `${PROTOCOL}${PATTERN_URL_WITHOUT_PROTOCOL}`;
const PATTERN_URL_WITH_REQUIRED_PROTOCOL_WORD = `^${PATTERN_URL_WITH_REQUIRED_PROTOCOL}$`;

export const REG_EXP_URL_WITH_OPTIONAL_PROTOCOL = new RegExp(
  PATTERN_URL_WITH_OPTIONAL_PROTOCOL
);

export const REG_EXP_URL_WITH_REQUIRED_PROTOCOL = new RegExp(
  PATTERN_URL_WITH_REQUIRED_PROTOCOL
);

export const REG_EXP_URL_WITH_OPTIONAL_PROTOCOL_GLOBALLY = new RegExp(
  REG_EXP_URL_WITH_OPTIONAL_PROTOCOL,
  'g'
);
export const REG_EXP_URL_WITH_OPTIONAL_PROTOCOL_WORD = new RegExp(
  PATTERN_URL_WITH_OPTIONAL_PROTOCOL_WORD
);

export const REG_EXP_URL_WITH_REQUIRED_PROTOCOL_WORD = new RegExp(
  PATTERN_URL_WITH_REQUIRED_PROTOCOL_WORD
);

export const REG_EXP_PROTOCOL = new RegExp(`^${PROTOCOL}`);

export const REG_EXP_CIRILLICA = '[а-яА-Яё]+';

const PORT = '(:\\d{1,5})?';
const LOCALHOST_HOST = '(localhost|127\\.0\\.0\\.1)';
const LOCALHOST_URL = `(${PROTOCOL})?${LOCALHOST_HOST}${PORT}${PATH}`;

const PATTERN_URL_WITHOUT_PROTOCOL_WITH_PORT = `${DOMAIN_PARTS}${TLD}${PORT}${PATH}`;
const PATTERN_URL_WITH_OPTIONAL_PROTOCOL_WITH_PORT = `${PROTOCOL}${PATTERN_URL_WITHOUT_PROTOCOL_WITH_PORT}|${DOMAIN_PARTS_WITH_LETTER}${TLD_WITH_LETTER}${PORT}${PATH}`;

const PATTERN_WIDGET_URL = `${LOCALHOST_URL}|${PATTERN_URL_WITH_OPTIONAL_PROTOCOL_WITH_PORT}`;
const PATTERN_WIDGET_URL_WORD = `^(?:${PATTERN_WIDGET_URL})$`;

export const REG_EXP_WIDGET_URL_WORD = new RegExp(PATTERN_WIDGET_URL_WORD);

/**
 * Ссылка на набор custom emoji Telegram. Повторяет серверный `CUSTOM_EMOJI_SET_URL_RE`:
 * принимается только каноническая форма `t.me/addemoji/{name}`, имя набора берётся из пути.
 */
const CUSTOM_EMOJI_SET_NAME = '[A-Za-z0-9_]{1,64}';
const PATTERN_CUSTOM_EMOJI_SET_URL_WORD = `^(?:https?://)?(?:www\\.)?t\\.me/addemoji/${CUSTOM_EMOJI_SET_NAME}/?$`;

export const REG_EXP_CUSTOM_EMOJI_SET_URL_WORD = new RegExp(
  PATTERN_CUSTOM_EMOJI_SET_URL_WORD
);
